import { CircleProfileImage } from '@nucleus/sermon-theme-elements';
import { FocalPoint } from '@nucleus/types/media/image';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface PostAuthorProfileProps {
  children?: React.ReactNode;
  to?: string;
  blurHash?: string;
  focalPoint?: FocalPoint;
  src?: string;
  srcSet?: string;
}

export const PostAuthorProfile = (props: PostAuthorProfileProps): JSX.Element => {
  const content = (
    <ProfileContainer>
      <AuthorImage blurHash={props.blurHash} focalPoint={props.focalPoint} src={props.src} srcSet={props.srcSet} />
      <AuthorNameContainer>{props.children}</AuthorNameContainer>
    </ProfileContainer>
  );

  if (props.to === undefined) {
    return content;
  }

  return <StyledLink to={props.to}>{content}</StyledLink>;
};

const AuthorNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const ProfileContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

const AuthorImage = styled(CircleProfileImage)`
  flex-shrink: 0;
  width: 8.33cqi;
  height: 8.33cqi;
  border-width: 2px;
`;

const StyledLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
